module.exports = __webpack_public_path__ + "static/img/3904_phase_function_Paper_Points.9d69b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3904_phase_function_Paper_Points.png
// module id = l358
// module chunks = 0